export * from './application/wishlist-service.interface';
